module.exports = __webpack_public_path__ + "static/15-578a1f43b55309720eb5dcf1dd4c65f1.jpg";